import { useQuery } from "@tanstack/react-query";
import { api, ApiError } from "@/lib/api";

export interface MeResponse {
  email: string;
  name: string | null;
  picture: string | null;
  authenticated: true;
}

export function useMe() {
  return useQuery<MeResponse | null>({
    queryKey: ["auth", "me"],
    queryFn: async () => {
      try {
        return await api<MeResponse>("/api/auth/me");
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) {
          return null;
        }
        throw err;
      }
    },
    retry: false,
    staleTime: 60_000,
  });
}

export function loginUrl(
  returnUrl: string = window.location.origin + "/",
) {
  // Absolute returnUrl is required so the OAuth callback (which lands on the
  // .NET backend's origin in dev — e.g. https://localhost:7157) redirects
  // back to wherever the user actually started (Vite's :5174 in dev,
  // same-origin in prod). Relative URLs would just land on the .NET origin.
  return `/api/auth/login/google?returnUrl=${encodeURIComponent(returnUrl)}`;
}
